module.exports = __webpack_public_path__ + "static/media/csttimg.7ad0f631.jpeg";